import React, { useState ,useEffect} from 'react'
import {  useParams } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import pencil from './iconos/pencil.svg'
import websal from './iconos/logowebsal.png'
import Swal from 'sweetalert2'
import { Loading } from './Loading';
import {  MobileView,  } from 'react-device-detect';


export const VerPdf = () => {

    const data = useSelector(state => state.login.data)
    
    // console.log('DATAAAAAAAAA',data)


    const rut = data ?  data.personaId : null

    // console.log('RUUUUUUUUUT',rut)
    
    const {id,codper} = useParams()

  
    // console.log('codper',codper)

  

    const [objPdf, setobjPdf] = useState( {
        firmas: 0,
        link: "https://www.websal.com/docs/001/hwn1vpy4/7lj07ks12hss/1546-202205-cnw7xkwhlh.pdf",
        base64:'',
        maxFirmas:2,
        firmantes:[]
    })

    // console.log('VEAMOS',objPdf)

    
    // const emailsFirmantes =  objPdf.firmantes.map(({email}) => {
    //     return [email];
    //   })
    //   console.log('emailsFirmantes',emailsFirmantes.flat())
    

    // const propiedades = objPdf.firmantes


    // const result = propiedades.find(item => item[`${rut}`] === true);

  

    const [loadingDoc, setLoadingDoc] = useState(false)

 

    const consultarDatos = async () => {

        setLoadingDoc(true)

        try {

            
            const response = await axios.get(`${process.env.REACT_APP_API_URL_BACK}api/firma/byId/${id}`);
                    
            // console.log(response.data)
              
             setobjPdf(response.data[0])
             setLoadingDoc(false)

             return response.data[0]


            } catch (error) {
             setLoadingDoc(false)
              
             console.log(error)
                
            }


    }

    useEffect(() => {

        consultarDatos()
    }, [])

    const [ip, setip] = useState('')
    
    const consultarip = async () => {
        try {

            const response = await axios.get(`https://api.ipify.org`);
                    
            // console.log(response.data)
              
            setip(response.data)



            } catch (error) {
              
            // alert("Error de conexion","Intentalo otra vez", );
            console.log('error al obtener ip',error)
                
            }


    }

    useEffect(() => {

        consultarip()
    }, [])

    let nuevoFlujo = objPdf.maxFirmas === 2 && objPdf.firmas === 0 ? 'contraparte' : objPdf.maxFirmas === 2 && objPdf.firmas === 1 ? 'stopMail' : objPdf.maxFirmas === 1 ? 'stopMail' : null
    
    

//    console.log(data)

   const [loading, setloading] = useState(false)
    
   const firmarAction = async () => {

    // hacemos esto para ver si firmo antes desde otra pestana o otro navegador o del celular
     const resp = await consultarDatos()



    if(resp.firmaTrabajador === true ) {
        return
    }


    
    let emails = {}

    if(objPdf.maxFirmas == 3){
       emails= {
        emailTrabajador: objPdf.emailTrabajador,
        emailContraparte: objPdf.emailContraparte,
        emailContraparte2: objPdf.emailContraparte2
       }
    }
    if(objPdf.maxFirmas == 2){
       emails= {
        emailTrabajador: objPdf.emailTrabajador,
        emailContraparte: objPdf.emailContraparte
       }
    }

    if(objPdf.maxFirmas == 1){
      emails= {
        emailTrabajador: objPdf.emailTrabajador
       }
    }

    setloading(true)

    try {
    //    console.log('hla')

        if( objPdf.maxFirmas !== 3 ){

                if(objPdf.maxFirmas === 2 && objPdf.firmas === 0 ){
                    //  Si tiene max 2 firmas y firmas 0 es posible que se haya firmado en el momento que se vea el doc
                    // console.log('POSIBILIDAD SIMULTANEO')

                    const responseDoc = await axios.get(`${process.env.REACT_APP_API_URL_BACK}api/firma/byId/${id}`);
                    const propsDoc = responseDoc.data[0]

                            const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/firma/firmar`,
                            {
                                link:propsDoc.link, firmas: propsDoc.firmas, id:propsDoc.id, rut:propsDoc.idTrabajador, nombre:propsDoc.nombreTrabajador, so:'pc', ip: ip ? ip : '-', tipo:propsDoc.tipo, flujo:propsDoc.flujo, nuevoFlujo, emails, maxFirmas:propsDoc.maxFirmas, persona:'trabajador', codper:propsDoc.codper, portal:propsDoc.sid, empid:propsDoc.empid, empresa:localStorage.getItem('empresa'), nombreTrabajador:propsDoc.nombreTrabajador
                            });
                            
                                        if(response.data.link ){

                                            Swal.fire({
                                                title: 'Documento Firmado',
                                                confirmButtonColor:'#2ec1db',
                                                
                                            })

                                            setloading(false)
                                
                            
                                
                                            
                                        }
                }else {
                    // console.log('NO SIMULTANEO')



                            const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/firma/firmar`,
                            {
                            link:objPdf.link, firmas: objPdf.firmas, id:objPdf.id, rut:objPdf.idTrabajador, nombre:objPdf.nombreTrabajador, so:'pc', ip: ip ? ip : '-', tipo:objPdf.tipo, flujo:objPdf.flujo, nuevoFlujo:nuevoFlujo, emails, maxFirmas:objPdf.maxFirmas, persona:'trabajador', codper:objPdf.codper, portal:objPdf.sid, empid:objPdf.empid, empresa:localStorage.getItem('empresa'), nombreTrabajador:objPdf.nombreTrabajador
                            });
                
                
                            if(response.data.link ){
                
                                        Swal.fire({
                                            title: 'Documento Firmado',
                                            confirmButtonColor:'#2ec1db',
                                            
                                            })
                            
                                            setloading(false)
                                
                            }
                }
            


            
        }
        if(objPdf.maxFirmas === 3){

                    // si o si puede ser simultaneo, por ende comprobamos

                    const responseDoc = await axios.get(`${process.env.REACT_APP_API_URL_BACK}api/firma/byId/${id}`);
                    const propsDoc = responseDoc.data[0]

                    if( propsDoc.flujo == 'trabajador' && propsDoc.firmas == 0 ){
                        nuevoFlujo = 'contraparte'
                    }
                    if( propsDoc.flujo == 'trabajador' && propsDoc.firmas == 2 ){
                        nuevoFlujo = 'stopMail'
                    }
                    if( propsDoc.flujo == 'simultaneo' ){
                        nuevoFlujo = 'simultaneo'
                    }


                    const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/firma/firmar3`,
                    {
                        link:propsDoc.link, firmas: propsDoc.firmas, id:propsDoc.id, rut:propsDoc.idTrabajador, nombre:propsDoc.nombreTrabajador, so:'pc', ip: ip ? ip : '-', tipo:propsDoc.tipo, flujo:propsDoc.flujo, nuevoFlujo, emails, maxFirmas:propsDoc.maxFirmas, persona:'trabajador', codper:propsDoc.codper, portal:propsDoc.sid, empid:propsDoc.empid, empresa:localStorage.getItem('empresa'), nombreTrabajador:propsDoc.nombreTrabajador
                    });
                    
                                if(response.data.link ){

                                    Swal.fire({
                                        title: 'Documento Firmado',
                                        confirmButtonColor:'#2ec1db',
                                        
                                    })

                                    setloading(false)
                        
                    
                        
                                    
                                }



                    
                    
        }

                        
       
            consultarDatos()
        

         } catch (error) {
                
                    console.log(error)
                    Swal.fire({
                        title: 'Error al firmar',
                        confirmButtonColor:'#2ec1db',
                        
                    })
                    setloading(false)
                    
                }




   }





  return (
    <div className='contenedorPdf'>

      {
        loadingDoc ? <Loading/> 
        :
        <>
                    {
                    objPdf.codper == codper ? 
                                <>
                                
                                <div>     
                                                            <div className='contenedorLogoFirma'>
                                                                    <img  className='websalFirma animate__animated animate__fadeIn' src={websal} alt='ver' />
                        
                                                            </div>
                        
                        
                        
                                                                <div className='contenedorFirmas'>
                        
                        
                        
                                                                <p className='ultimo tituloDocumento' >Documento: {objPdf.tipo} </p>
                        
                        
                        
                                                                
                                                                        
                                                                            <div className='documentos'>
                                                                                    <p className='nombre' > {objPdf.nombreTrabajador} </p>
                                                                                
                        
                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                    <p>RUT</p>
                                                                                    <p> { objPdf.idTrabajador } </p>
                                                                                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                        
                                                                                    <p>Fecha firma</p>
                                                                                    <p>{objPdf.fechaTrabajador ?objPdf.fechaTrabajador : '-' } </p>
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                                                                                
                                                                                    <p>IP</p>
                                                                                    <p> {objPdf.ipTrabajador ? objPdf.ipTrabajador : '-' } </p>
                        
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma last' >
                        
                                                                                    <p>Firmado desde</p>
                                                                                    <p className='ultimo' > {objPdf.soTrabajador ? objPdf.soTrabajador.toUpperCase() : '-'} </p>
                        
                                                                                </div>
                                                                                
                        
                                                                        </div>
                        
                                                                        {
                                                                        objPdf.idContraparte &&
                        
                                                                        <div className='documentos'>
                                                                                    <p className='nombre' > {objPdf.nombreContraparte} </p>
                                                                                
                        
                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                    <p>RUT</p>
                                                                                    <p> { objPdf.idContraparte } </p>
                                                                                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                        
                                                                                    <p>Fecha firma</p>
                                                                                    <p>{objPdf.fechaContraparte ?objPdf.fechaContraparte : '-' } </p>
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                                                                                
                                                                                    <p>IP</p>
                                                                                    <p> {objPdf.ipContraparte ? objPdf.ipContraparte : '-' } </p>
                        
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma last' >
                        
                                                                                    <p>Firmado desde</p>
                                                                                    <p className='ultimo' > {objPdf.soContraparte ? objPdf.soContraparte.toUpperCase() : '-'} </p>
                        
                                                                                </div>
                                                                                
                        
                                                                        </div>
                        
                        
                                                                        }

                                                                { objPdf.maxFirmas === 3 &&
                                                                                            
                                                                                            <div className='documentos'>
                                                                                            
                                                                                                <p className='nombre' > {objPdf.nombreContraparte2} </p>
                                                                                        

                                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                                    <p>RUT</p>
                                                                                                    <p> {objPdf.idContraparte2} </p>
                                                                                                        
                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma' >

                                                                                                    <p>Fecha firma</p>
                                                                                                    <p>{objPdf.fechaContraparte2 ? objPdf.fechaContraparte2 : '-' } </p>

                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma' >
                                                                                                
                                                                                                    <p>IP</p>
                                                                                                    <p> {objPdf.ipContraparte2 ? objPdf.ipContraparte2 : '-' } </p>


                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma last' >

                                                                                                    <p>Firmado desde</p>
                                                                                                    <p className='ultimo' > {objPdf.soContraparte2 ? objPdf.soContraparte2.toUpperCase() : '-'} </p>

                                                                                                </div>
                                                                                                

                                                                                        </div>
                                                                                            
                                                                                            
                                                                                            }
                        
                                                                        
                        
                                                                            
                        
                                                                            
                        
                                                                <p className='tituloDocumento'> Firmas: {objPdf.firmas} </p>
                        
                        
                                                                        {
                                                                            loading && <Loading/>
                                                    
                                                                        }
                        
                        
                                                                            {
                                                                            rut === objPdf.idTrabajador && objPdf.firmaTrabajador === false && loading === false  &&
                        
                                                                            <button onClick={firmarAction} className='firmarButton' >
                                                                            Firmar
                        
                                                                            <img  className='firmarPencil animate__animated animate__fadeIn' src={pencil} alt='ver' />
                                                                            </button>
                                                                            }
                        
                        
                                                                </div>
                        
                        
                        
                                                    </div>
                        
                                                
                        
                        
                                                <div className='pdf' >
                        
                        
                                                    {
                                                        objPdf.link &&
                        
                                                        <object
                                                
                                                        data={`https://websalsign.s3.amazonaws.com/${objPdf.link}`}
                                                        type="application/pdf" width="100%" height="100%"></object>
                                                    }
                        
                                        <MobileView>
                                            <div className='contenedorDescargarTelefono'>
                                            <a href={`https://websalsign.s3.amazonaws.com/${objPdf.link}`} className="descargarTelefono" download target="_blank">Descargar</a>

                                            </div>
                        
                                        </MobileView>
                                                                        
                                                  
                        
                                                        
                        
                                                        
                                                </div>
                                
                                
                                
                                
                                
                                </>
                        
                                :
                            
                                <p className='errorMsg' >Error: No existe este documento</p>
                        
                    }
        </>
    }
      
    
                       



      
        
       
     </div>
  )
}
